export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10118.3f2d7aca.jpg";